/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContentListEntryFromJSON, ContentListEntryToJSON, } from './ContentListEntry';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfContentListEntry interface.
 */
export function instanceOfPagedResponseOfContentListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfContentListEntryFromJSON(json) {
    return PagedResponseOfContentListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfContentListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(ContentListEntryFromJSON)),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext']
    };
}
export function PagedResponseOfContentListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPage': PageRequestToJSON(value.nextPage),
        'page': value.page,
        'metaData': MetaDataToJSON(value.metaData),
        'size': value.size,
        'hasPrevious': value.hasPrevious,
        'previousPage': PageRequestToJSON(value.previousPage),
        'totalElements': value.totalElements,
        'numberOfElements': value.numberOfElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(ContentListEntryToJSON)),
        'hasNext': value.hasNext
    };
}
